export default __webpack_public_path__ + "static/media/african-tech-team.ce77f37a.webp";